/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Quaint_Aqua_Mole_BaskInputs */

const fr_quaint_aqua_mole_bask = /** @type {(inputs: Quaint_Aqua_Mole_BaskInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Les programmes en continu sont des programmes qui n'ont pas de durée.`)
};

/**

* @param {Quaint_Aqua_Mole_BaskInputs} inputs
* @param {{ locale?: "fr" }} options
* @returns {LocalizedString}
*/
export const quaint_aqua_mole_bask = /** @type {((inputs?: Quaint_Aqua_Mole_BaskInputs, options?: { locale?: "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Quaint_Aqua_Mole_BaskInputs, { locale?: "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return fr_quaint_aqua_mole_bask(inputs)
});